import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';
import ProjectSetupChatbot from './ProjectSetupChatbot';
import { ProjectSetupData } from './AIProjectSetupModal';

interface ProjectSetupChatbotModalProps {
  open: boolean;
  onClose: () => void;
  onProjectSetup: (data: ProjectSetupData) => void;
}

export const ProjectSetupChatbotModal: React.FC<ProjectSetupChatbotModalProps> = ({
  open,
  onClose,
  onProjectSetup,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={() => {}} // Prevent closing by clicking outside
      disableEscapeKeyDown // Prevent closing with ESC key
      maxWidth={false} // Disable maxWidth to use custom width
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          height: isMobile ? '100vh' : '80vh',
          maxHeight: isMobile ? '100vh' : '800px',
          width: isMobile ? '100vw' : '700px', // Set custom 700px width
          maxWidth: isMobile ? '100vw' : '700px',
          position: 'relative',
        },
      }}
    >


      <DialogContent sx={{ p: 0, height: '100%', overflow: 'hidden' }}>
        <ProjectSetupChatbot 
          onProjectSetup={onProjectSetup} 
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ProjectSetupChatbotModal;